var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6675_6168)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 0.25H23.75V23.75H0.25V0.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81104 7.96436H14.1607V15.9375H9.81104V7.96436Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0874 11.9525C10.0847 11.188 10.2539 10.4327 10.5825 9.74246C10.9111 9.05221 11.3906 8.44468 11.9857 7.9648C9.94783 6.33155 7.02134 6.56949 5.26178 8.51191C3.50222 10.4543 3.50295 13.4491 5.26178 15.3915C7.02061 17.334 9.94709 17.5719 11.9857 15.9379C11.3909 15.4583 10.9115 14.8511 10.5829 14.1612C10.2543 13.4714 10.085 12.7166 10.0874 11.9525Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0294 11.952C20.0294 13.8929 18.9426 15.6635 17.2315 16.5125C15.5204 17.3614 13.4825 17.1374 11.9858 15.9374C12.5806 15.4575 13.06 14.8502 13.3888 14.1603C13.7176 13.4704 13.8874 12.7155 13.8857 11.9513C13.8857 10.3959 13.1851 8.92563 11.9858 7.96434C13.4825 6.7651 15.5182 6.54185 17.2307 7.39006C18.9433 8.23826 20.0294 10.0088 20.0294 11.9505V11.952Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6675_6168"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.45aa7df77af24cfb9b5817e19419a739.svg";
export { ForwardRef as ReactComponent };